import {inject, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Title} from '@angular/platform-browser';
import {LoadingController, MenuController, Platform} from '@ionic/angular';
import {environment} from '@environments/environment';
import {BottomMenu} from '@core/classes/bottom-menu';
import {FirebaseX} from '@awesome-cordova-plugins/firebase-x/ngx';
import {FirebasePlugin} from 'cordova-plugin-firebasex';
import {InAppBrowser} from '@awesome-cordova-plugins/in-app-browser';

const _window = (): any => window;
declare let cordova: any;

@Injectable({
  providedIn: 'root',
})
export class AppService {
  title = inject(Title);
  platform = inject(Platform);
  firebasex = inject(FirebaseX);
  loading: any;
  isLoading = false;
  loadingCounter = 0;
  menu: MenuController;
  // modalService = inject(ModalService);
  // toastController = inject(ToastController);
  public appReadySubject = new BehaviorSubject(false);
  bottomMenu = new BottomMenu();
  bottomMainModal = false;
  mainModalIsOpen = false;
  bottomPanelNeedHidden = false;
  phone = '';
  email = '';
  deviceId: string;
  public appVersionNumber: string;
  postError = false;
  httpError = false;
  postErrorList = 0;
  showMainPopup = false;
  hamsterQrRelocation = false;
  menuIsOpen = false;

  constructor(
    public loadingController: LoadingController,
    menu: MenuController) {
    this.menu = menu;
    console.log('%c[APP_SERVICE] Lobsterlab. Z2S App v:' + this.getVersion(), 'color: #5d81b7; font-size: 18px; font-weight: bold');
    (window as any).app = this;
    console.log('[APP_SERVICE] AppService constructor finished');
  }

  public get appReady() {
    return this.appReadySubject.getValue();
  }

  public set appReady(value) {
    this.appReadySubject.next(value);
  }

  setTitle(title: string) {
    this.title.setTitle(title);
  }

  formatPhoneNumber(phoneNumber: string): string {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/);
    if (match) {
      return `+${match[1]} (${match[2]}) ${match[3]} ${match[4]} ${match[5]}`;
    }
    return phoneNumber;
  }

  // callPhone(phone: string | null = null) {
  //   this.openLink('tel:' + (phone !== null ? phone : this.phone), false);
  // }
  //
  // callChat() {
  //   // console.log('to chat');
  // }
  //
  // sendMail(mail: string | null = null) {
  //   this.openLink('mailto:' + (mail !== null ? mail : this.email ? this.email : 'mail@z2s.ru'), false);
  // }

  callPhone() {
    window.open('tel:' + this.phone, '_self');
  }

  sendEmail() {
    window.open('mailto:' + this.email, '_self');
  }

  openLink(url: string, appBrowser = true) {
    // appBrowser нужен так как некторые ссылки
    // нужно открывать принудительно не в appBrowser
    if (this.isCordova() && appBrowser) {
      // Скрываем статус бар
      // @ts-ignore
      StatusBar.hide();
      // @ts-ignore
      StatusBar.overlaysWebView(true);
      const browserRef = InAppBrowser.create(url, '_blank', {
        location: 'yes', // Показывает адресную строку
        toolbar: 'yes', // Включает верхний тулбар
        lefttoright: this.isAndroid() ? 'yes' : 'no',
        closebuttoncaption: 'Назад', // Устанавливает текст кнопки "Назад"
        closebuttoncolor: '#484848', // Устанавливает цвет текста кнопки "Назад".
        toolbarcolor: '#F9F9F9', // Устанавливает цвет тулбара
        hidenavigationbuttons: 'yes', // Скрывает кнопки навигации,
        hideurlbar: 'yes',
        fullscreen: 'yes',
        toolbarposition: 'top',
        zoom: 'no'
      });

      browserRef.on('loadstop').subscribe(event => {
        // Дополнительные действия при загрузке страницы
      });
      // Показать статус бар при закрытии InAppBrowser
      browserRef.on('exit').subscribe(() => {
        // @ts-ignore
        StatusBar.show();
      });
    } else {
      window.open(url, '_self');
    }
  }

  isCordova() {
    return this.platform.is('cordova');
  }

  isAndroid() {
    return this.platform.is('android');
  }

  isIos() {
    return this.platform.is('ios');
  }

  isDevice() {
    return this.isCordova() && (this.isAndroid() || this.isIos());
  }

  getVersion(callback?: () => void) {
    this.appVersionNumber = environment.version;
    return environment.version;
  }

  addUserToPush(userId = null) {
    console.log('[APP_SERVICE] addUserToPush: Start with userId', userId);
    if (userId) {
      console.log('[APP_SERVICE] addUserToPush: Subscribing to userId', userId);
      this.firebasex.subscribe(userId);
      console.log('[APP_SERVICE] addUserToPush: Setting userId', userId);
      this.firebasex.setUserId(userId);
    } else {
      console.log('[APP_SERVICE] addUserToPush: No user ID provided, doing nothing');
    }
    console.log('[APP_SERVICE] addUserToPush: End');
  }

  async openMenu() {
    await this.toggleMenuIsOpen(true);
    await this.menu.open();
  }

  async closeMenu() {
    await this.toggleMenuIsOpen(false);
    await this.menu.close();
  }

  async toggleMenuIsOpen(value: boolean) {
    this.menuIsOpen = value;
  }

  async subscribePush(callback: () => void, callbackPush: (data: any) => void = null) {
    console.log('[APP_SERVICE] subscribePush: Start');

    // Register the listener before native token and topic calls, which may stall.
    this.firebasex.onMessageReceived().subscribe(data => {
      if (callbackPush) {
        callbackPush(data);
      }
    });

    if (this.isIos()) {
      console.log('[APP_SERVICE] subscribePush: Running on iOS. Subscribing to \'ios\'.');
      await this.firebasex.subscribe('ios');
      console.log('[APP_SERVICE] subscribePush: Subscribed to \'ios\'.');
    }

    if (this.isAndroid()) {
      console.log('[APP_SERVICE] subscribePush: Running on Android. Subscribing to \'android\'.');
      await this.firebasex.subscribe('android');
      console.log('[APP_SERVICE] subscribePush: Subscribed to \'android\'.');
    }

    console.log('[APP_SERVICE] subscribePush: Subscribing to \'all\'.');
    await this.firebasex.subscribe('all');
    console.log('[APP_SERVICE] subscribePush: Subscribed to \'all\'.');

    console.log('[APP_SERVICE] subscribePush: Checking for permission...');
    const status = await this.firebasex.hasPermission();
    console.log('[APP_SERVICE] subscribePush: Permission status:', status);
    if (!status) {
      console.log('[APP_SERVICE] subscribePush: No permission. Requesting permission...');
      this.firebasex.grantPermission().then((e) => {
        console.log('[APP_SERVICE] subscribePush: grantPermission result:', e);
      }).catch(error => {
        console.error('[APP_SERVICE] subscribePush: grantPermission failed:', error);
      });
    }

    console.log('[APP_SERVICE] subscribePush: Getting token...');
    await this.firebasex.getToken().then(token => {
      console.log('[APP_SERVICE] subscribePush: Got token');
      this.deviceId = token;

      callback();
      console.log('[APP_SERVICE] subscribePush: Callback executed after getToken.');
    }).catch(error => {
      console.error('[APP_SERVICE] subscribePush: getToken failed:', error);
      // Если getToken падает, мы все равно должны продолжить подписываться на onMessageReceived?
      // Возможно, стоит вызвать callback здесь или позже, в зависимости от желаемого поведения.
      // Пока оставляем как есть, callback вызывается только при успешном получении токена.
    });

    console.log('[APP_SERVICE] subscribePush: End');
  }

  public unSubscribePush(userId = null) {
    console.log('[APP_SERVICE] unSubscribePush: Start with userId', userId);
    this.firebasex.clearAllNotifications();
    console.log('[APP_SERVICE] unSubscribePush: clearAllNotifications called');

    if (this.isIos()) {
      console.log('[APP_SERVICE] unSubscribePush: Running on iOS. Unsubscribing from \'ios\'.');
      this.firebasex.unsubscribe('ios');
      console.log('[APP_SERVICE] unSubscribePush: Unsubscribed from \'ios\'.');
    }

    if (this.isAndroid()) {
      console.log('[APP_SERVICE] unSubscribePush: Running on Android. Unsubscribing from \'android\'.');
      this.firebasex.unsubscribe('android');
      console.log('[APP_SERVICE] unSubscribePush: Unsubscribed from \'android\'.');
    }

    if (userId) {
      console.log('[APP_SERVICE] unSubscribePush: Unsubscribing from userId', userId);
      this.firebasex.unsubscribe(userId);
      console.log('[APP_SERVICE] unSubscribePush: Unsubscribed from userId', userId);
    }
    console.log('[APP_SERVICE] unSubscribePush: End');
  }

  async showLoading() {
    console.log('[APP_SERVICE] showLoading: Start. loadingCounter:', this.loadingCounter);
    this.loadingCounter++;

    if (!this.isLoading) {

      this.isLoading = true;
      console.log('[APP_SERVICE] showLoading: Creating and presenting loading controller.');
      this.loading = await this.loadingController.create({
        cssClass: 'custom-loading',
      });
      await this.loading.present();
      console.log('[APP_SERVICE] showLoading: Loading presented.');
    }
    console.log('[APP_SERVICE] showLoading: End. loadingCounter:', this.loadingCounter);
  }

  async hideLoading(all = false) {
    console.log('[APP_SERVICE] hideLoading: Start. all:', all, 'loadingCounter:', this.loadingCounter);
    this.loadingCounter--;

    if (all) {
      this.loadingCounter = 0;
      console.log('[APP_SERVICE] hideLoading: all is true, setting loadingCounter to 0.');
    }

    if (this.loadingCounter <= 0) {
      console.log('[APP_SERVICE] hideLoading: loadingCounter is 0 or less. Hiding loading.');

      // Добавляем класс для анимации
      console.log('[APP_SERVICE] hideLoading: Adding hide-loading class.');
      await this.loading?.classList.add('hide-loading');
      // Оборачиваем в setTimeout на 600, чтобы перед dismiss
      // успела отработать анимация плавного скрытия лоадера
      await setTimeout(() => {
        if (this.loading) {
          this.loading.dismiss();
          this.loading = null;
        }

        this.loadingCounter = 0;

        if (this.isLoading) {
          this.isLoading = false;
          console.log('[APP_SERVICE] hideLoading: Dismissing loading controller.');
          return this.loadingController.dismiss(null, 'cancel');
        }
        console.log('[APP_SERVICE] hideLoading: setTimeout callback finished.');
      }, 600);
    }

    console.log('[APP_SERVICE] hideLoading: End. loadingCounter:', this.loadingCounter);
    return null;
  }

  async back() {
    // if (this.isLoading) {
    //   return false;
    // }

    // close popover
    await this.closeToast();

    // close modal
    // await this.modalService.closeTopModal();

  }


  async closeToast() {
    // try {
    // const element = await this.toastController.getTop();
    // if (element) {
    //   await element.dismiss();
    //   return;
    // }
    // } catch (error) {
    // }
  }

  getWindow() {
    return _window();
  }

  logError(data: {
    title: string;
    type: string;
    data?: any;
    error?: any;
  }) {
    console.log('[APP_SERVICE] logError: Start', data);
    data.data.prodMode = environment.production ? 'production' : 'debug';
    const firebasePlugin: FirebasePlugin = this.getWindow().FirebasePlugin;
    if (!firebasePlugin) {
      console.warn('[APP_SERVICE] logError: FirebasePlugin no initialized into window');
      return;
    }
    // Устанавливаем кастомные ключи ошибки
    if (data.data) {
      for (const key in data.data) {
        if (data.data.hasOwnProperty(key)) {
          firebasePlugin.setCrashlyticsCustomKey(key, data.data[key]);
        }
      }
    }
    // Устанавливаем тип ошибки в кастомный ключ
    firebasePlugin.setCrashlyticsCustomKey('type', data.type);

    // Получаем стек ошибки, если можем
    // StackTrace.fromError(data.error)
    //   .then((stack) => {
    //     firebasePlugin.logError(data.title, stack, () => {
    //       // console.log('%cSend error to firebase 🔥\n' + '%c' + data.error.stack, 'color:#ff6a00', 'color: #838c95');
    //     });
    //   })
    //   .catch((err) => {
    //     firebasePlugin.logError(data.title, null, () => {
    //       // console.log('%cSend error to firebase 🔥\n' + '%c' + data.error.message, 'color:#ff6a00', 'color: #838c95');
    //     });
    //   });
    console.log('[APP_SERVICE] logError: End');
  }
}
